<template>
  <section>
    <div class="l-service">
      <div class="l-service-header">
        <h2 class="heading-default heading-default-center">
          株主・投資家の皆さまへ
        </h2>
        <h3 class="heading-small heading-small-center heading-small-mt-sp">
          TOP MESSAGES
        </h3>
        <section>
          <div class="l-service-content-inner">
            <div class="l-service-header">
              <p class="service-message service-message-mt">
                当社代表取締役社長小林祐樹から株主・投資家の皆さまに向けてのメッセージを掲載しています。
              </p>
              <div class="l-csr-section-bottom-button">
                <div class="button">
                  <a class="button-inner" href="/ir/message">
                    <div class="button-text">株主・投資家の皆さまへ</div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div class="l-service-illust">
            <h2 class="heading-default heading-default-center">IRニュース</h2>
            <h3 class="heading-small heading-small-center heading-small-mt-sp">
              IR NEWS
            </h3>

            <div class="l-service-content-inner">
              <!-- E-IR Parts -->
              <div id="eirArea"></div>
              <!-- /E-IR Parts -->

              <div class="l-csr-section-bottom-button">
                <div class="button">
                  <a class="button-inner" href="/ir/news">
                    <div class="button-text">IRニュース一覧</div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div class="l-service-content">
            <h2 class="heading-default heading-default-center">
              IRライブラリー
            </h2>
            <h3 class="heading-small heading-small-center heading-small-mt-sp">
              IR LIBRARY
            </h3>
            <div class="l-service-content-inner">
              <div class="l-container-padding">
                <div class="l-home-about-link">
                  <div class="l-grid l-grid-col4 l-grid-sm-col1">
                    <div class="l-grid-inner">
                      <div class="l-grid-item l-grid-item-box">
                        <div class="box">
                          <a
                            href="/ir/library"
                            class="js-link-animation-inside"
                          >
                            <div class="box-background">
                              <div
                                class="box-background-image"
                                style="
                                  background-image: url('img/main_library.png');
                                "
                              ></div>
                              <div
                                class="box-background-image-sp"
                                style="
                                  background-image: url('img/main_library_sp.png');
                                "
                              ></div>
                            </div>
                            <div class="box-content">
                              <h2 class="box-title">
                                <span class="box-title-main">決算短信</span>
                                <span class="box-title-sub box-title-sub-margin"
                                  >FINANCIAL RESULTS</span
                                >
                              </h2>
                            </div>
                            <span class="box-mark">
                              <i class="box-mark-icon"></i>
                            </span>
                          </a>
                        </div>
                      </div>
                      <div class="l-grid-item l-grid-item-box">
                        <div class="box">
                          <a
                            href="/ir/securities"
                            class="js-link-animation-inside"
                          >
                            <div class="box-background">
                              <div
                                class="box-background-image"
                                style="
                                  background-image: url('img/main_securities.png');
                                "
                              ></div>
                              <div
                                class="box-background-image-sp"
                                style="
                                  background-image: url('img/main_securities_sp.png');
                                "
                              ></div>
                            </div>
                            <div class="box-content">
                              <h2 class="box-title">
                                <span class="box-title-main"
                                  >有価証券報告書</span
                                >
                                <span class="box-title-sub box-title-sub-margin"
                                  >SECURITIES REPORT</span
                                >
                              </h2>
                            </div>
                            <span class="box-mark">
                              <i class="box-mark-icon"></i>
                            </span>
                          </a>
                        </div>
                      </div>
                      <div class="l-grid-item l-grid-item-box">
                        <div class="box">
                          <a
                            href="/ir/presentation"
                            class="js-link-animation-inside"
                          >
                            <div class="box-background">
                              <div
                                class="box-background-image"
                                style="
                                  background-image: url('img/main_presentation.png');
                                "
                              ></div>
                              <div
                                class="box-background-image-sp"
                                style="
                                  background-image: url('img/main_presentation_sp.png');
                                "
                              ></div>
                            </div>
                            <div class="box-content">
                              <h2 class="box-title">
                                <span class="box-title-main"
                                  >決算説明会資料</span
                                >
                                <span class="box-title-sub box-title-sub-margin"
                                  >PRESENTATION</span
                                >
                              </h2>
                            </div>
                            <span class="box-mark">
                              <i class="box-mark-icon"></i>
                            </span>
                          </a>
                        </div>
                      </div>
                      <div class="l-grid-item l-grid-item-box">
                        <div class="box">
                          <a
                            href="/ir/material"
                            class="js-link-animation-inside"
                          >
                            <div class="box-background">
                              <div
                                class="box-background-image"
                                style="
                                  background-image: url('img/main_material.png');
                                "
                              ></div>
                              <div
                                class="box-background-image-sp"
                                style="
                                  background-image: url('img/main_material_sp.png');
                                "
                              ></div>
                            </div>
                            <div class="box-content">
                              <h2 class="box-title">
                                <span class="box-title-main">IR資料</span>
                                <span class="box-title-sub box-title-sub-margin"
                                  >IR MATERIALS</span
                                >
                              </h2>
                            </div>
                            <span class="box-mark">
                              <i class="box-mark-icon"></i>
                            </span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div class="l-service-illust">
            <div class="l-service-content-inner mt_0">
              <section class="l-about-section l-about-section-content">
                <div
                  class="
                    l-grid l-grid-col2 l-grid-sm-col1 l-grid-box-card-margin
                    mt_0
                  "
                >
                  <div class="l-grid-inner">
                    <div class="l-grid-item l-grid-item-box">
                      <div class="box-card">
                        <a href="/ir/governance">
                          <div class="box-card-background">
                            <div
                              class="box-card-background-image"
                              style="
                                background-image: url('img/main_governance.jpg');
                              "
                            ></div>
                            <div
                              class="box-card-background-image-sp"
                              style="
                                background-image: url('img/main_governance_sp.jpg');
                              "
                            ></div>
                          </div>
                          <div class="box-card-content">
                            <h2 class="box-card-title">
                              <span class="box-card-title-main">経営方針</span>
                              <span
                                class="
                                  box-card-title-sub box-card-title-sub-margin
                                "
                                >MANAGEMENT POLICY</span
                              >
                            </h2>
                            <span class="box-card-mark">
                              <i class="box-card-mark-icon"></i>
                            </span>
                          </div>
                        </a>
                      </div>
                    </div>
                    <div class="l-grid-item l-grid-item-box">
                      <div class="box-card">
                        <a href="/ir/highlight">
                          <div class="box-card-background">
                            <div
                              class="box-card-background-image"
                              style="
                                background-image: url('img/main_highlight.jpg');
                              "
                            ></div>
                            <div
                              class="box-card-background-image-sp"
                              style="
                                background-image: url('img/main_highlight_sp.jpg');
                              "
                            ></div>
                          </div>
                          <div class="box-card-content">
                            <h2 class="box-card-title">
                              <span class="box-card-title-main"
                                >業績ハイライト</span
                              >
                              <span
                                class="
                                  box-card-title-sub box-card-title-sub-margin
                                "
                                >FINANCIAL HIGHLIGHTS</span
                              >
                            </h2>
                            <span class="box-card-mark">
                              <i class="box-card-mark-icon"></i>
                            </span>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  class="
                    l-grid l-grid-col2 l-grid-sm-col1 l-grid-box-card-margin
                  "
                >
                  <div class="l-grid-inner">
                    <div class="l-grid-item l-grid-item-box">
                      <div class="box-card">
                        <a href="/ir/schedule">
                          <div class="box-card-background">
                            <div
                              class="box-card-background-image"
                              style="
                                background-image: url('img/main_schedule.jpg');
                              "
                            ></div>
                            <div
                              class="box-card-background-image-sp"
                              style="
                                background-image: url('img/main_schedule_sp.jpg');
                              "
                            ></div>
                          </div>
                          <div class="box-card-content">
                            <h2 class="box-card-title">
                              <span class="box-card-title-main"
                                >IRカレンダー</span
                              >
                              <span
                                class="
                                  box-card-title-sub box-card-title-sub-margin
                                "
                                >IR CALENDAR</span
                              >
                            </h2>
                            <span class="box-card-mark">
                              <i class="box-card-mark-icon"></i>
                            </span>
                          </div>
                        </a>
                      </div>
                    </div>
                    <div class="l-grid-item l-grid-item-box">
                      <div class="box-card">
                        <a href="/ir/stock">
                          <div class="box-card-background">
                            <div
                              class="box-card-background-image"
                              style="
                                background-image: url('img/main_stock.jpg');
                              "
                            ></div>
                            <div
                              class="box-card-background-image-sp"
                              style="
                                background-image: url('img/main_stock_sp.jpg');
                              "
                            ></div>
                          </div>
                          <div class="box-card-content">
                            <h2 class="box-card-title">
                              <span class="box-card-title-main"
                                >株式について</span
                              >
                              <span
                                class="
                                  box-card-title-sub box-card-title-sub-margin
                                "
                                >STOCK INFORMATION</span
                              >
                            </h2>
                            <span class="box-card-mark">
                              <i class="box-card-mark-icon"></i>
                            </span>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </section>
        <section class="ir_top_list">
          <div class="l-service-content2">
            <div class="l-service-content-inner">
              <ul>
                <li class="ir_top_menu top_line">
                  <a href="/ir/faq">よくあるご質問</a>
                </li>
                <li class="ir_top_menu">
                  <a href="https://www.tabikobo.com/form/ir/">IRお問い合わせ</a>
                </li>
                <li class="ir_top_menu">
                  <a href="/ir/notice">電子公告</a>
                </li>
                <li class="ir_top_menu">
                  <a href="/ir/disclaimer">免責事項</a>
                </li>
              </ul>
            </div>
          </div>
        </section>
      </div>
    </div>
    <div id="doEirWrapper"></div>
  </section>
</template>

<script>
import jQuery from "jquery";

export default {
  metaInfo() {
    return {
      title: "IR情報トップ",
      titleTemplate: "IR情報トップ | IR情報 | 株式会社 旅工房",
    };
  },
  mounted: function () {
    jQuery("body").addClass("IRtop");
    let doEirWrapper = document.getElementById("doEirWrapper");
    let doEirScript = document.createElement("script");
    doEirScript.innerHTML = 'setParts("top")';
    doEirWrapper.appendChild(doEirScript);
  },
};
</script>
